{
  "resources": "WATCH_DURATION",
  "filters": [
    {
      "key": "{{:resourceType:}}",
      "value": "{{:id:}}",
      "op": "=="
    }
  ],
  "dateRange": {
    "start": "{{:startDateTime:}}",
    "end": "{{:endDateTime:}}"
  }
}